export default __webpack_public_path__ + "static/media/poster.3601114c.png";